import { render } from "./developAIModel.vue?vue&type=template&id=75a3dd34&scoped=true"
import script from "./developAIModel.vue?vue&type=script&lang=js"
export * from "./developAIModel.vue?vue&type=script&lang=js"

import "./developAIModel.vue?vue&type=style&index=0&id=75a3dd34&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a3dd34"]])

export default __exports__